// extracted by mini-css-extract-plugin
export default {"image":"FileElement_image__FY4UA","container":"FileElement_container__CMAnR","link":"FileElement_link__srMR-"};